import { render, staticRenderFns } from "./EditCompanyComponent.vue?vue&type=template&id=5e8b90dc&scoped=true"
import script from "./EditCompanyComponent.vue?vue&type=script&lang=js"
export * from "./EditCompanyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8b90dc",
  null
  
)

export default component.exports